import { FiltersController } from "@components/commerce/product-listing/filters/context/FiltersContextProvider";
import { INITIAL_HITS_PER_PAGE } from "@components/commerce/product/list/product-list-footer/ProductListFooter";
import { SearchResultsPLP } from "@components/search/SearchResultsPLP";
import type { ISiteSettings } from "@contentful-api/types/contentful";
import type { NextPageWithLayout } from "@interfaces/PageInterfaces";
import { getAdditionalSizesFilters } from "@lib/utils/plp/plpShoeSizes";
import type { SearchProps } from "@pages/search";
import { useStore } from "@store/index";
import { deserialize } from "@ungap/structured-clone";
import { isEmpty } from "lodash-es";
import dynamic from "next/dynamic";
import { useEffect } from "react";
import { Configure, useSearchBox } from "react-instantsearch";

const SearchInput = dynamic(
    () => import("@components/search/SearchInput").then((mod) => mod.SearchInput),
    { ssr: false }
);

const SearchCarousels = dynamic(
    () => import("@components/search/SearchCarousels").then((mod) => mod.SearchCarousels),
    { ssr: false }
);

const queryHook = (query, search) => {
    if (query) {
        search(query);
    }
};

export const SearchPageTemplate: NextPageWithLayout<Partial<SearchProps>> = ({
    serializedSiteSettings,
    serializedPage,
    query,
    locale,
}) => {
    const page = deserialize(serializedPage);
    const siteSettings: ISiteSettings = deserialize(serializedSiteSettings);

    const listOfFilters = [
        ...(page?.fields?.filtersList ?? []),
        ...getAdditionalSizesFilters(page?.fields?.filtersList),
    ];
    const customLinksCarousel = page?.fields?.customLinksCarousel;
    const sortByOptionsList = page?.fields?.sortByOptionsList || [];

    const { refine } = useSearchBox({
        queryHook,
    });

    useEffect(() => {
        refine(query?.query as string);
    }, [query]);

    const lastLoadedPage = useStore((state) => state.data.products?.lastLoadedPage ?? 1);

    return (
        <>
            {isEmpty(query) && <SearchInput />}
            {!isEmpty(query) && (
                <FiltersController
                    listOfFilters={listOfFilters}
                    sortByOptionsList={sortByOptionsList}
                    page={lastLoadedPage}
                >
                    <Configure
                        // @ts-ignore
                        query={query?.query}
                        facetFilters={"hasStock:true"}
                        hitsPerPage={INITIAL_HITS_PER_PAGE * lastLoadedPage}
                    />
                    <SearchResultsPLP
                        listOfFilters={listOfFilters}
                        authorizationInvitation={siteSettings?.fields?.authorizationInvitation}
                        routerQuery={query}
                        locale={locale}
                    />
                </FiltersController>
            )}
            {isEmpty(query) && <SearchCarousels customLinksCarousel={customLinksCarousel} />}
        </>
    );
};
